"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9099],{

/***/ 9099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _2_stats_Stats; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/assets/images/home/Flag.webp
/* harmony default export */ var Flag = ({"src":"/_next/static/media/Flag.02b94bae.webp","height":169,"width":168,"blurDataURL":"data:image/webp;base64,UklGRq4AAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDEAAAAFYBrZVqtLxlEEisLA0QyegoJDxka+jC1ExATgK7VONx+oNUDWCfeMXzWS08clCp4BAFZQOCBWAAAAsAEAnQEqCAAIAAJAOCWIAnQBFKB22ADiZrb2rbb2HBnVPIKo2DHwqvJx3V4wJkW707R2/1Xpvuh4R5DhHVpLIHdqX9ubP5+uuZf/JcdcEX+Te6OgAAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/StatsBorderTop.webp
/* harmony default export */ var StatsBorderTop = ({"src":"/_next/static/media/StatsBorderTop.69010318.webp","height":94,"width":2880,"blurDataURL":"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAAQAAAABwAAAAAAQUxQSAkAAAAAEhITEhQSExMAVlA4ICIAAABwAQCdASoIAAEAAkA4JYwCdAFAAAD++jPIq9XoyeT9V8AA","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./public/assets/images/home/StatsOrangeBand.webp
/* harmony default export */ var StatsOrangeBand = ({"src":"/_next/static/media/StatsOrangeBand.510b9a03.webp","height":52,"width":720,"blurDataURL":"data:image/webp;base64,UklGRjgAAABXRUJQVlA4ICwAAADQAQCdASoIAAEAAkA4JaACdLoB+AADsAD+7OMv/MEr8g3kL/8btxhvy8AAAA==","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./public/assets/images/home/StatsGreenBand.webp
/* harmony default export */ var StatsGreenBand = ({"src":"/_next/static/media/StatsGreenBand.6da1fdfc.webp","height":52,"width":720,"blurDataURL":"data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACQAQCdASoIAAEAAkA4JaACdLoAA5gA/uHDf+xZy2BeP689TFuAAA==","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ./utils/Constants.ts
var Constants = __webpack_require__(953);
;// CONCATENATED MODULE: ./components/home/2-stats/Stats.tsx








const Stats = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        sx: {
            width: "100vw",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            position: "relative",
            padding: {
                xs: "50px 0 0 0",
                md: "60px 0 0 0"
            },
            minHeight: {
                xs: "50vh",
                md: "50vh"
            },
            mb: 8,
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                sx: {
                    height: {
                        xs: "32px",
                        md: "48px"
                    },
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: StatsBorderTop,
                    alt: "",
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    },
                    loading: "lazy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                sx: {
                    width: "100%",
                    maxWidth: "1200px",
                    margin: "auto",
                    display: "block",
                    padding: {
                        xs: "12px 24px 16px",
                        md: "24px 24px 16px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingBottom: {
                                xs: "16px",
                                md: "24px"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body1",
                            fontWeight: "bold",
                            textAlign: "center",
                            color: "#6C717F",
                            textTransform: "capitalize",
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: {
                                    xs: "16px",
                                    md: "20px"
                                },
                                paddingLeft: {
                                    xs: "0",
                                    md: "0"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Made for India, Made in India"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: Flag,
                                    alt: "Indian flag icon",
                                    style: {
                                        height: "42px",
                                        width: "42px",
                                        marginLeft: "4px",
                                        verticalAlign: "middle"
                                    },
                                    loading: "lazy"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                sx: {
                                    width: {
                                        xs: "20%",
                                        md: "360px"
                                    },
                                    height: {
                                        xs: "16px",
                                        md: "fit-content"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: StatsOrangeBand,
                                    alt: "",
                                    // width={720}
                                    // height={52}
                                    // style={{ width: "720px", height: "52px" }}
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                textAlign: "center",
                                fontWeight: "bold",
                                sx: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingBottom: {
                                        xs: "10px",
                                        md: "0"
                                    },
                                    fontSize: {
                                        xs: "40px",
                                        md: "64px"
                                    },
                                    zIndex: 2,
                                    whiteSpace: "nowrap"
                                },
                                children: Constants/* NUMBER_OF_DOWNLOADS */.Gv + " " + "Lakh+"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                sx: {
                                    width: {
                                        xs: "20%",
                                        md: "360px"
                                    },
                                    height: {
                                        xs: "16px",
                                        md: "fit-content"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: StatsGreenBand,
                                    alt: "",
                                    // width={720}
                                    // height={52}
                                    // style={{ width: "720px", height: "52px" }}
                                    loading: "lazy"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        textAlign: "center",
                        fontWeight: "700",
                        sx: {
                            textShadow: "0px 0px 4px white",
                            fontSize: {
                                xs: "18px",
                                md: "32px"
                            },
                            width: {
                                xs: "70%",
                                md: "fit-content"
                            },
                            margin: "auto",
                            paddingBottom: {
                                xs: "8px",
                                md: "16px"
                            }
                        },
                        children: "Partners have earned ₹100 Crores till now!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        textAlign: "center",
                        sx: {
                            textShadow: "0px 0px 2px white",
                            fontSize: {
                                xs: "13px",
                                sm: "14px",
                                md: "18px"
                            },
                            lineHeight: {
                                xs: "19px",
                                sm: "20px",
                                md: "26px"
                            },
                            width: {
                                xs: "86%",
                                md: "720px"
                            },
                            margin: "auto",
                            fontWeight: 500,
                            opacity: 0.95,
                            paddingBottom: {
                                xs: "12px",
                                md: "40px"
                            }
                        },
                        children: "GroMo is a free app that turns you into a certified financial advisor. Share product links, help people get credit cards & loans, earn commission on every sale. No investment needed."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _2_stats_Stats = (Stats);


/***/ })

}]);